import axios from "axios";
export const API_ROOT = process.env.REACT_APP_API_ROOT;
export const FILE_PATH = process.env.REACT_APP_FILE_PATH;
export const BASEURL = process.env.REACT_APP_BASE_URL_ROOT;

// Axios Instance
const api = axios.create({
  baseURL: API_ROOT,
  headers: {
    "X-API-KEY": process.env.REACT_APP_API_KEY,
    "X-API-SECRET": process.env.REACT_APP_API_SECRET,
  },
});

// Common API Methods
const apiRequest = {
  get: async (url, params = {}) => {
    const response = await api.get(url, { params });
    return response.data;
  },

  post: async (url, data = {}) => {
    const response = await api.post(url, data);
    return response.data;
  },

  put: async (url, data = {}) => {
    const response = await api.put(url, data);
    return response.data;
  },

  patch: async (url, data = {}) => {
    const response = await api.patch(url, data);
    return response.data;
  },

  delete: async (url) => {
    const response = await api.delete(url);
    return response.data;
  },
};

export default apiRequest;